// extracted by mini-css-extract-plugin
export default {"edit":"CategoryEdit-module__edit__AlmZs","form":"CategoryEdit-module__form__xWtpl","footer":"CategoryEdit-module__footer__FQMWv","button":"CategoryEdit-module__button__Bfl9T"};